import { CustomValidationService } from './modules/validation/validation-service';
import { NativeValidationService } from './modules/validation/native-validation-service';
import { LoadingOverlayService } from './modules/ui/loading-overlay-service';
import { AddressService } from './modules/address/address-service';
import { CheckoutAddressService } from './modules/address/checkout-address-service';
import { PaymentService } from './modules/payment/payment-service';
import { FormService } from './modules/forms/form-service';
import { UIUtilities } from './modules/ui/ui-utilities';
import { initSwipers } from './modules/ui/swiper'

// Import styles and dependencies
import './scss/main.scss'
import 'bootstrap/dist/js/bootstrap.bundle.js'


console.log("Starting CIWM Frontend...");

// Application class that coordinates all modules
class CIWMApp {
    private validationService: CustomValidationService;
    private addressService: AddressService;
    private checkoutAddressService: CheckoutAddressService;
    private paymentService: PaymentService;
    private formService: FormService;

    constructor() {
        this.validationService = new CustomValidationService();
        this.addressService = new AddressService();
        this.checkoutAddressService = new CheckoutAddressService();
        this.paymentService = new PaymentService();
        this.formService = new FormService();
    }

    public initialize(): void {
        // Initialize validation first
        this.validationService.initialize();
        
        // Initialize other services when DOM is ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.initializeServices();
            });
        } else {
            // DOM is already ready
            this.initializeServices();
        }
    }

    private initializeServices(): void {
        this.addressService.initialize();

        // Only initialize checkout address service on checkout pages
        if (document.querySelector('.checkout-form')) {
            this.checkoutAddressService.initialize();
        }

        this.formService.initialize();

        // Set up global functions for backward compatibility
        this.setupGlobalFunctions();

        // Initialise UI widgets
        initSwipers();
    }

    private setupGlobalFunctions(): void {
        // Make payment functions available globally for Stripe integration
        window.initializeEventBookingPayment = this.paymentService.initializeEventBookingPayment.bind(this.paymentService);
        window.initializeMembershipApplicationPayment = this.paymentService.initializeMembershipApplicationPayment.bind(this.paymentService);
        window.initializeShopOrderPayment = this.paymentService.initializeShopOrderPayment.bind(this.paymentService);

        // Make App object available globally for backward compatibility
        window.App = {
            defaults: {
                pageName: "Pagination.CurrentPage"
            },
            
            init: () => this.initialize(),
            
            initForms: () => this.formService.initialize(),
            
            smoothScrollTo: UIUtilities.smoothScrollTo,
            
            slideUp: UIUtilities.slideUp,
            
            slideDown: UIUtilities.slideDown,
            
            initSwitchList: UIUtilities.initSwitchList,
            
            // Modern services
            loadingOverlay: LoadingOverlayService.getInstance(),
            nativeValidation: NativeValidationService.getInstance(),
            
            // Legacy methods for backward compatibility
            performAjax: (element: HTMLFormElement, successFunc: Function, errorFunc: Function) => {
                // Delegate to form service's performAjax method
                (this.formService as any).performAjax(element, successFunc, errorFunc);
            },
            
            resetFormPage: (element: HTMLFormElement) => {
                (this.formService as any).resetFormPage(element);
            },
            
            changePage: (element: Element, pageNum?: number) => {
                (this.formService as any).changePage(element, pageNum);
            }
        };
    }
}



// Initialize the application
const app = new CIWMApp();
app.initialize();

// Export for module usage if needed
//export default app;